import React, { useEffect } from 'react';
import classnames from 'classnames';

import Show from 'components/Show';
import Chat from 'components/Messenger/Chat';
import Contacts from 'components/Messenger/Contacts';
import Conversations from 'components/Messenger/Conversations';

import { useAppStore } from 'store/useAppStore';
import { useMessengerStore } from 'store/useMessengerStore';

const Messenger = () => {
	// Use app's store
	const [user, messenger, socket] = useAppStore(state => [state.user, state.messenger, state.socket]);

	// Use messenger's store
	const [view, pending, onAddConversation, onAddMessage, onReadMessage, onActive, onReset] = useMessengerStore(state => [
		state.view,
		state.pending,
		state.onAddConversation,
		state.onAddMessage,
		state.onReadMessage,
		state.onActive,
		state.onReset
	]);

	// Concat messenger classname
	const cls = classnames(
		'fixed z-10 top-14 flex flex-col h-[calc(100%-56px)] w-full sm:max-w-xs bg-white dark:bg-neutral-800 border-l dark:border-none transition-all',
		messenger ? 'right-0' : '-right-full'
	);

	// Listen to messenger events
	useEffect(() => {
		// Recieve conversation
		socket?.on('new-conversation', data => {
			// Add conversation to store
			onAddConversation(data);

			// Find participant that is not user
			const participant = data.participants.find(p => p.id !== user.id);

			// Move to new conversation only if pending convo is same
			if (data.type === 'private' && pending?.id === participant?.id) {
				onActive(data.id);
			}
		});

		// Recieve message in some conversation
		socket?.on('new-message', data => {
			onAddMessage(data);
		});

		// Recieve readby for some message
		socket?.on('read-message', data => {
			onReadMessage(data);
		});

		return () => {
			socket?.off('new-conversation');
			socket?.off('new-message');
			socket?.off('read-message');
		};
	}, [socket, pending]);

	// Reset messenger's store
	useEffect(() => {
		return () => {
			onReset();
		};
	}, []);

	return (
		<div className={cls}>
			{/* Messenger's contact view */}
			<Show if={view === 'conversations'}>
				<Conversations />
			</Show>

			{/* Messenger's contact view */}
			<Show if={view === 'contacts'}>
				<Contacts />
			</Show>

			{/* Messenger's chat view */}
			<Show if={view === 'chat'}>
				<Chat />
			</Show>
		</div>
	);
};

export default Messenger;
